<template>
  <div>
    <div class="page-header">
      <div class="container-fluid d-flex align-items-center justify-content-between">
       <h4 class="h no-margin-bottom">Grup İşlemler ({{ table }})</h4>
       <div class="right-menu list-inline no-margin-bottom">
          <router-link to="/defines/cihazgrup"><button type="submit" class="btn submit bg-dark text-light mr-w">Ana Gruplar</button>
          </router-link>
          <router-link to="/liste/cihaz"><button type="submit" class="btn submit bg-dark text-light">Cihazlar</button>
          </router-link>
       </div>
      </div>
    </div>

  <section class="no-padding-top no-padding-bottom">
      <div class="container-fluid">
          <div class="block" v-if="table!='altgrup'">
            <div class="block-body">
             <div class="form-group">
              <div class="row">
              <div class="col-lg-3 col-12">
                <label class="form-control-label dashtext-3">Cihaz Anagrup</label>
                <select v-model="newPost.grupkodu"  class="form-control">
                  <option value="0">Cihaz Grubunu seç</option>
                  <option v-for="option in grup" :value="option.kodu" :key="option.kodu">{{ option.alias }}
                  </option>
                </select>
              </div>
               <div class="col-lg-3 col-12">
                <label class="form-control-label dashtext-3">Kodu</label>
                <input placeholder="Min 6 karakter" type="text" class="form-control" v-model="newPost.kodu"/>
              </div>
               <div class="col-lg-3 col-12">
                <label class="form-control-label dashtext-3">Alias</label>
                <input @keyup="this.$helper.tabloarama" id="arama" placeholder="Min 6 karakter" type="text" class="form-control" v-model="newPost.alias"/>  
              </div> 
              <div class="col-lg-3 col-12">
                <label class="form-control-label dashtext-3">Ağrlık</label>
                <input placeholder="Kilogram" type="text" class="form-control" v-model="newPost.agirlik"/>
              </div>
            </div>
            <div class="row mt-3">
               <div class="col-lg-3 col-12">
                <label class="form-control-label dashtext-3">Genişlik</label>
                <input placeholder="Santimetre" type="text" class="form-control" v-model="newPost.genislik"/>
              </div>
               <div class="col-lg-3 col-12">
                <label class="form-control-label dashtext-3">Derinlik</label>
                <input placeholder="Santimetre" type="text" class="form-control" v-model="newPost.derinlik"/>
              </div>
               <div class="col-lg-3 col-12">
                <label class="form-control-label dashtext-3">Yükseklik</label>
                <input placeholder="Santimetre" type="text" class="form-control" v-model="newPost.yukseklik"/>
              </div>
               <div class="col-lg-3 col-12 mt-4 p-2">
<button @click="sendNewPost()" class="btn btn-danger w-100">{{progres.mesaj}}</button>
              </div>                                                        
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-2 p-2">
            <div class="col-12">
                <input class="form-control" placeholder="Genel Arama" id="arama" type="text" @keyup="this.$helper.tabloarama"/>
            </div>
          </div>
              <div class="row">
                <div class="col-12" >
                <div class="block margin-bottom-sm">
                  <div class="table-responsive"> 
                    <table id="tablo" class="table">
                      <thead>
                        <tr>
                          <th>Anakod</th>
                          <th>Grup</th>
                          <th>Kod</th>
                          <th>Alias</th>
                          <th>Genişlik</th>
                          <th>Yükseklik</th>
                          <th>Derinlik</th>
                          <th>Ağırlık</th>
                          <!-- <th v-if="table!='altgrup'">Düzenle</th> -->
                          
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(caris,index) in posts" :key="index" >
                          <td>{{caris.akod}}</td>
                          <td>{{caris.alias}}</td>
                          <td>{{caris.mkod}}</td>
                          <td>{{caris.malias}}</td>
                          <td>{{caris.genislik}} cm.</td>
                          <td>{{caris.yukseklik}} cm.</td>
                          <td>{{caris.derinlik}} cm.</td>
                          <td>{{caris.agirlik}} kg.</td>
                          <!-- <td v-if="$helper.sayfayetki(516410)" class="text-info">
                              <a @click="aktar(index)">Düzenle</a>
                          </td> -->
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                </div>
              </div>      
            <div class="row">
              <div class="col-12">
                <div class="footer__block block no-margin-bottom">
                  <div v-if="errors && errors.length" class="container-fluid text-center">
                    <div class="loading dashtext-2">Veritabanı Hatası</div>
                     <ul>
                        <li v-for="(error, index) of errors" :key="index">
                          {{ index + 1 }} - {{ error.message }}
                        </li>
                      </ul>
                  </div>
                </div>
              </div>
            </div>      
    </div>
  </section>
  <div v-if="progres.inprogres" class="loading"><img src="/set/ajax-loader.gif"/></div>
</div>
</template>
<script>

  export default {  
    created() {
      this.progres.inprogres=true
      this.yetki();
      
    },
    data() {
      return {
        progres : {
        mesaj:'Bekleyiniz',
        inprogres:true
      },
        posts: [],
        errors: [],
        grup:[],
        ya:this.$request.ayar().ya,
        kid:this.$request.ayar().kid,
        table:this.$route.params.table,
        newPost:
              {
                firma : this.$request.ayar().firmaid,
                kodu :'',
                alias:'',
                grupkodu:0,
                table :this.$route.params.table,
                genislik:0,
                derinlik:0,
                yukseklik:0,
                agirlik:0
             },
             tabledata :[],
             source:[]

      };
    },
    methods: {
      aktar(index){
        if (this.table=='altgrup') {
          this.$swal("Farklı Kaynak, işlem yapılamaz")

        }
        else {
            var source = this.posts[index]
            console.log(source)
            this.mode = "Düzenle ( Yeni kayıt için sayfayı yenileyin )"
        }

        },      
        yetki(){ 
          if (this.$helper.sayfayetki(516410)){
            let islem =false;
            switch(this.ya) {
              case 'said':
                this.ya = 'said';
                islem = true
                break;
              case 'carid':
                this.ya='carid';
                islem = true;
                break;
              default:
                islem = true;
                this.ya = 'fid';
            }
                if(islem){
                  if (this.table != 'altgrup') {
                    this.getir(this.cihazgrup);

                  }
                  else {
                    this.altgruplar();
                  }
                
                }
          }
          else{
                alert('Bu alanı kullanım yetkiniz yok')
                this.$router.go(-1)
          }
        
        },
        altgruplar(data){
          this.$request.post("servis/api", {q:'cihaz_list',isim:this.$request.ayar().f1,where:{}})
          .then(res => {
            this.posts = [];
            console.log(res.data)
          this.$request.gruplama(res.data,'cihazgrup','anakod','cihazaltgrup','altkod').then(data => {
            data.forEach(grp => {
              grp.nodes.forEach(ele => {
                this.posts.push({
                    akod:grp.kodu,
                    alias:grp.alias,
                    mkod:ele.kodu,
                    malias:ele.alias
                  })
              });
              });
          })
          this.progres.inprogres=false
          }).catch(err=>{
            console.log(err)
          })


        },
        cihazgrup(data){

          this.$request.post("servis/api", {q:'cihaz_list',where:{},isim:this.$request.ayar().f1})
          .then(res => {

          this.$request.gruplama(res.data,'cihazgrup','anakod','cihazaltgrup','altkod')
            .then(res => {
              this.grup = res
              this.progres.mesaj="Kayıt Ekle";
              this.posts = []
              res.forEach(grp => {
                const result = data.filter((word) => word.grupkodu == grp.kodu);

                result.forEach(ele => {
                  this.posts.push({
                    akod:grp.kodu,
                    alias:grp.alias,
                    mkod:ele.kodu,
                    malias:ele.alias
                  })
              });
              });
            })

            })
            this.progres.inprogres=false

        },
        getir(callback){
          this.progres.inprogres=true

         this.$request.get("servis/altgrup/"+this.newPost.firma+"/"+'tbl_'+this.table+'/mikro').then(res => {
                this.tabledata = res.results;
                  callback(res.results)
            })
          
        },

      sendNewPost() {
        if (this.newPost.kodu && this.newPost.alias && this.newPost.grupkodu!=''){
          this.progres.inprogres = true
            this.$request.post("servis/define/",this.newPost )
            .then( res =>{
             this.$swal("Kayıt Ekleme Başarılı")
             this.getir(this.cihazgrup)
            }
          )
        .catch(err => this.$swal(err.message))
        this.progres.inprogres = false;
        }
        else{
          this.$swal("Girdileri Kontrol Et")
        }
      },
    },
    watch : {
        "$route.params.table":function(val) {
          this.table = val
          this.yetki()
        },
      },     
  };
</script>
<style scoped>
.highlight {
  background:lightslategray;
  color: white;
}
li{list-style: none; display:inline-block}
</style>


// WEBPACK FOOTER //
// src/views/cihaz/altgrup.vue